export default __webpack_public_path__ + "static/media/320px-Flag_of_Andalucia.svg.c054ad99.png";